const dictionaryElement = document.querySelector('[data-dictionary]')
if (dictionaryElement) {
  const dictionaryData = dictionaryElement.getAttribute('data-dictionary')
  if (dictionaryData) {
    try {
      const dictionaryJson = JSON.parse(dictionaryData)
      window.dictionary = dictionaryJson
    } catch (error) {
      console.error('Failed to parse dictionary data as JSON', error)
    }
  }
}
